import request from '../request';
import md5 from 'js-md5';
/*
 */
export const withdrawAddressApi = {
  add(data) {
    return request({
      url: '/gw/p/withdraw/address',
      method: 'post',
      data,
    });
  },
  // 添加/修改提币地址
  // post (data) {
  //   const url = data.id ? `/withdraw/address/updateWallet` : `/api/w/withdraw/address`;
  //   return request({
  //     url,
  //     method: 'post',
  //     data,
  //   });
  // },
  // 删除提币地址
  delete(data) {
    return request({
      url: `/gw/p/withdraw/address`,
      method: 'delete',
      params: data,
    });
  },
  // 查询指定币种的钱包地址列表
  getWithdrawAddressByCoinId(coinId) {
    return request({
      url: `/gw/p/withdraw/address/${coinId}`,
      method: 'get',
    });
  },
  getWithdrawalFee(params) {
    return request({
      url: `/gw/w/withdraw/fee`,
      method: 'get',
      params,
    });
  },
  // 查询所有币种的钱包地址列表
  getListAll() {
    return request({
      url: `/api/w/withdraw/address/listAll`,
      method: 'get',
    });
  },
  withdraw(data) {
    data.payPassword = md5(data.payPassword);
    return request({
      url: `/gw/w/withdraw`,
      method: 'post',
      data,
    });
  },
};
